<script lang="ts">
export default {
  name: 'DownloadButton',
};
</script>

<script setup lang="ts">
import AppButton from '@/components/v2/AppButton.vue';
import { Download } from '@lucide/vue';

const emit = defineEmits<{
  click: any;
}>();

withDefaults(
  defineProps<{
    disabled?: boolean;
    loading?: boolean;
  }>(),
  {
    disabled: false,
    loading: false,
  },
);
</script>

<template>
  <app-button class="rounded-md" :disabled="disabled" @click="emit('click')">
    <span v-if="loading" class="loading loading-spinner loading-xs"></span>
    <Download v-else :size="16" class="hyperlink-icon stroke-primary" />
  </app-button>
</template>
